import { queryOptions } from '@tanstack/react-query';
import { Domain, } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const unavailabilityKeys = {
    all: ['unavailabilities'],
    get: (filter, scope) => ['unavailabilities', filter, scope],
};
export const unavailabilityOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: unavailabilityKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Unavailability);
            return repo.get(filter, scope);
        },
    }),
    create: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.Unavailability);
            return repo.create(requests);
        },
    }),
    update: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.Unavailability);
            return repo.update(requests);
        },
    }),
    remove: () => ({
        mutationFn: async (requests) => {
            const repo = await resolveRepository(Domain.Unavailability);
            return repo.remove(requests);
        },
    }),
};
